import { createSlice } from '@reduxjs/toolkit';

// Admin Mollie Connect card — mirrors store/stripe/stripeSlice.js's
// requestStart/requestFailure loading-flag convention.
const initialState = {
  status: null, // { connected } once fetched
  isLoading: false,
  error: null
};

const mollieSlice = createSlice({
  name: 'mollie',
  initialState,
  reducers: {
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    fetchStatusSuccess: (state, action) => {
      state.status = action.payload;
      state.isLoading = false;
    },
    // Local optimistic update once mollie/disconnect succeeds — same "mutate the slice from the
    // known result, no extra round trip" convention as stripeSlice's disconnectSuccess.
    disconnectSuccess: state => {
      state.status = { connected: false };
      state.isLoading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchStatusSuccess,
  disconnectSuccess
} = mollieSlice.actions;

export default mollieSlice.reducer;
